<div [class]="classes" [ngClass]="{
	underTableHeader: underTableHeader,
	breakpoint_lg: breakpointAt == 1280,
	breakpoint_md: breakpointAt == 960,
	breakpoint_sm: breakpointAt == 600
}">
	<mat-progress-bar mode="indeterminate" *ngIf="show"></mat-progress-bar>
</div>